import React from 'react'
import ProtectedAreaView from './ProtectedAreaView'
import routesConfig from 'routesConfig'
import {useHistory} from 'react-router'
import {connect} from 'react-redux'
import {selectUserRegistered, selectUserLoggedIn} from 'store/user/reducer'
import {ACCESS_TOKEN} from "../../constants";
import {setAuthToken} from "../../api";

function LockedAreaContainer({userRegistered, userLoggedIn, children}) {
    const history = useHistory()
    const onRegister = () => history.push(routesConfig.register)
    const onLogin = () => history.push(routesConfig.login)
    const onLogout = () => {
        localStorage.removeItem(ACCESS_TOKEN);
        setAuthToken(null);
        window.location = "/";
    }

    return <ProtectedAreaView userLoggedIn={userLoggedIn} onLogin={onLogin}
                              userRegistered={userRegistered} onRegister={onRegister} onLogout={onLogout}>
        {children}
    </ProtectedAreaView>
}

const mapStateToProps = state => ({
    userRegistered: selectUserRegistered(state),
    userLoggedIn: selectUserLoggedIn(state)
})

export default connect(mapStateToProps)(LockedAreaContainer)
